<template>
    <div class="form">
        <div class="grid-x select-supply-wrapper">
            <div class="large-1 medium-1 small-1 cell flexbox-center">
                <icon class="supply-type small-svg fill-dark-gray" name="supply-type" />
            </div>
            <div class="large-3 medium-3 small-3 cell flexbox-align-items">
                <p>Forretningsområder</p>
            </div>
            <div class="auto cell select-supply flexbox-align-items">
                <div class="grid-x">
                    <div class="select-supply-container" v-for="supplytype in supplyTypes" v-bind:key="supplytype.code" @click="selectSupplyType(supplytype)">
                        <div class="button-radio-round" :id="supplytype.systemName.toLowerCase()" :class="{'selected-supply': checkSelected(supplytype)}">
                            <icon class="small-svg fill-white" :name="supplytype.systemName.toLowerCase()" />
                        </div>
                        <span>{{supplytype.description}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'supplytype',
    props: ['multiple'],
    data () {
        return {
            selectedSupplyTypeCode: ''
        }
    },
    computed: {
        ...mapGetters({
            selectedMultipleSupplyType: 'getSelectedMultipleSupplyType',
            supplyTypes: 'getSysBusinessAreaTypeList'
        })
    },
    methods: {
        ...mapActions({
            setSelectedMultipleSupplyTypeFromId: 'setSelectedMultipleSupplyTypeFromId'
        }),
        checkSelected (supplytype) {
            let found = false
            this.selectedMultipleSupplyType.forEach(sup => {
                if (sup.code === supplytype.code) {
                    found = true
                }
            })
            return found
        },
        selectSupplyType (supplyType) {
            if (supplyType.sysBusinessAreaTypeId) {
                this.setSelectedMultipleSupplyTypeFromId(supplyType.sysBusinessAreaTypeId)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/supplytype/supplytype.vue